import React from 'react'
import { useNavigate } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const SignInForm = ({ handleInput, formData, loading, password_error, setPassword_error }) => {

 const navigate = useNavigate();

  return (
    <>
      <InputGroup
        label="Email address"
        name="email"
        type="email"
        required={true}
        placeholder={'Enter your email address'}
        value={formData.email}
        onChange={handleInput}
        error={false}
      />
      <InputGroup
        componentType="password"
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        required={true}
        placeholder="*******"
        onChange={handleInput}
        error={password_error }
      seterror={setPassword_error}
      />
     
      <div className="forgotPassword--container">
        <Button tertiary onClick={()=>navigate("/auth/forgotten-password")}>Forgot Password?</Button>
      </div>
    
      <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
      >
        Log In
      </Button>
    </>
  )
}

export default SignInForm
